module.exports = __webpack_public_path__ + "img/jjsl.e6b342ec.png";